import React from 'react';
import { Info, Megaphone, Mail, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import i18n from '../i18n';

interface FooterLink {
  href: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  external?: boolean;
}

const LINKS: FooterLink[] = [
  // FAQ — раздел «Частые вопросы» в «Помощи» (раньше вела на «#», в никуда).
  { href: '/help#faq',                               label: 'FAQ',      icon: Info,          external: false },
  { href: 'https://telegram.me/spreadbotarbi',          label: i18n.t('appFooter:channel'),   icon: Megaphone,     external: true },
  { href: 'https://telegram.me/Daeddman',                   label: 'Telegram', icon: MessageCircle, external: true },
  { href: 'mailto:oleks.shevch@gmail.com',           label: i18n.t('appFooter:mail'),   icon: Mail },
];

export const AppFooter: React.FC = () => (
  <footer className="w-full border-t border-border bg-background">
    <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-3 px-4 py-4 text-[12px] text-muted-foreground sm:flex-row sm:gap-6 sm:px-6 lg:px-8">
      <div className="flex items-center gap-2 font-mono text-[11px]">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-md border border-border bg-card text-[10px] leading-none">⇄</span>
        <span>© {new Date().getFullYear()}</span>
        <span className="font-semibold text-foreground">spread.bot</span>
        <span className="text-muted-foreground/60">·</span>
        <span>{i18n.t('appFooter:rights')}</span>
      </div>
      <nav className="flex flex-wrap items-center justify-center gap-x-5">
        {LINKS.map(({ href, label, icon: Icon, external }) => href.startsWith('/') ? (
          <Link key={href} to={href}
            className="inline-flex items-center gap-1.5 py-2 transition-colors hover:text-foreground">
            <Icon className="h-3.5 w-3.5" />
            <span>{label}</span>
          </Link>
        ) : (
          <a
            key={href}
            href={href}
            {...(external ? { target: '_blank', rel: 'noreferrer noopener' } : {})}
            // py-2 — ссылки футера по 18px в высоту на телефоне были мельче пальца.
            className="inline-flex items-center gap-1.5 py-2 transition-colors hover:text-foreground"
          >
            <Icon className="h-3.5 w-3.5" />
            <span>{label}</span>
          </a>
        ))}
      </nav>
    </div>
  </footer>
);
